import { KeyboardEvent } from 'react';
import { Activators, KeyboardSensor, KeyboardSensorOptions } from '@dnd-kit/core';
/**
 * An extended "KeyboardSensor" that prevent some
 * interactive html element(button, input, textarea, select, option...) from dragging
 */

const isInteractiveElement = (element: Element | null) => {
	const interactiveElements = [
		'button',
		'input',
		'textarea',
		'select',
		'option',
		'svg',
		'label',
	];

	if (
		element?.tagName
        && interactiveElements.includes(element.tagName.toLowerCase())
	) {
		return true;
	}

	return false;
};

export class SmartKeyboardSensor extends KeyboardSensor {
	static activators: Activators<KeyboardSensorOptions> = [
		{
			eventName: 'onKeyDown' as const,
			handler:   (
				event: KeyboardEvent,
				options,
				context,
			) => {
				const { nativeEvent } = event;

				if (isInteractiveElement(nativeEvent.target as Element)) {
					return false;
				}

				// After checking for interactive element, run the onKeyDown activator from dnd-kit
				const onKeyDownActivator = KeyboardSensor.activators
					.find(activator => activator.eventName === 'onKeyDown');

				if (onKeyDownActivator) {
					return onKeyDownActivator.handler(event, options, context);
				}

				return true;
			},
		},
	];
}
